import { Flex } from "@acko-tech/building-blocks.ui.common";
import { useOnload } from "@utils/useOnLoad";
import React, { useContext } from "react";
import { Context } from "@components/useContext/context";
import DOMPurify from "isomorphic-dompurify";
import ImageContainer from "@components/imageContainer";
import { Container, Description, Heading } from "./styles";

const IdvDescription = ({ children, ...props }) => {
  const { desc, heading, styles, height, width, parentWrapperStyles, wrapperStyles, containerStyles, src, actions } = props || {};
  const { isDesktop } = useContext(Context);
  const { on_click, on_load } = actions || {};
  useOnload({ on_load });

  return (
    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
      <Container style={containerStyles}>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          style={ parentWrapperStyles}
        >
          {src && (
            <ImageContainer
              imgSrc={src}
              width={height}
              height={width}
              alt="product-image"
            />
          )}
          <Flex flexDirection="column" style={{ gap: "8px" }}>
            {heading && (
              <Heading
                wrapperStyles={wrapperStyles}
                isDesktop={isDesktop}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(heading)
                }}
              />
            )}
            <Description
              styles={styles}
              isDesktop={isDesktop}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(desc) }}
            />
          </Flex>
        </Flex>
      </Container>
    </Flex>
  );
};

export default IdvDescription;
